










































































































































































import { GetFileServiceUrl } from "@/helper/uploadHelper";
import { ExpenseType, Package, ParamsReloadType } from "@/enums/enums";
import { CheckMerchantPackage, MerchantId } from "@/helper/userHelper";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MainNavbar extends Vue {
  created() {
    this.listMenu = this.SetListMenu();
  }
  private hideDropdown = false;

  private listMenu: Array<any> = [];
  private Emi = 10;

  public SetListMenu() {
    const lislMenu = [
      {
        name: this.$t("Dashboard"),
        icon: "",
        img: GetFileServiceUrl("peakengine/Content/Image/PeakAsset/Menubar/AssetHome.png"),
        link: { name: "home" },
        lock: { value: true, text: "Lock_HeaderMenu" },
      },
      {
        name: this.$t("Purchase_Asset"),
        icon: "",
        img: GetFileServiceUrl("peakengine/Content/Image/PeakAsset/Menubar/AssetBuy.png"),
        link: null,
        canNotAccess: CheckMerchantPackage([Package.Free]),
        fullLink: `${process.env.VUE_APP_PeakAccount}expense/fixedAssetCreate?emi=${MerchantId().PeakEncryption()}`,
      },
      {
        name: this.$t("Sale_Asset"),
        icon: "",
        img: GetFileServiceUrl("peakengine/Content/Image/PeakAsset/Menubar/AssetSale.png"),
        link: null,
        fullLink: `${
          process.env.VUE_APP_PeakAccount
        }income/invoiceCreate?emi=${MerchantId().PeakEncryption()}&etiti=${ExpenseType.PurchaseAsset.PeakEncryption()}`,
      },
      {
        name: this.$t("Asset_Register"),
        icon: "",
        img: GetFileServiceUrl("peakengine/Content/Image/PeakAsset/Menubar/AssetDetails.png"),
        link: { name: "assetTemplate" },
        dropdown: [
          { name: this.$t("Asset_Register"), link: { name: "assetTemplate" } },
          { name: this.$t("Unit_Asset"), link: { name: "assetUnit" } },
        ],
      },
      {
        name: this.$t("Keeper"),
        icon: "",
        img: GetFileServiceUrl("peakengine/Content/Image/PeakAsset/Menubar/AssetKeeper.png"),
        link: { name: "keeper" },
        lock: { value: true, text: "Lock_HeaderMenu" },
      },
      {
        name: this.$t("Settings"),
        icon: "",
        img: GetFileServiceUrl("peakengine/Content/Image/PeakAsset/Menubar/AssetSetting.png"),
        link: { name: "setting" },
      },
    ];
    return lislMenu;
  }

  public checkActiveMenu(linkName: any) {
    if (linkName && this.$route.matched.length > 0) {
      if (linkName.name == this.$route.matched[0].name) {
        return true;
      } else {
        return false;
      }
    }
  }

  public SetQueryURL() {
    const query = {
      emi: MerchantId().PeakEncryption(),
      reload: ParamsReloadType.Reload,
    };

    return query;
  }

  public hide() {
    this.hideDropdown = true;
    setTimeout(() => {
      this.hideDropdown = false;
    }, 500);
  }
}
